import { Routes } from '@angular/router';
import { BookingComponent } from './booking.component';
import { BookingDetailsComponent } from './booking-details/booking-details.component';
import { PaymentReturnComponent } from './payment-return/payment-return.component';

export const bookingRoutes: Routes = [
  {
    path: '',
    component: BookingComponent
  },
  {
    path: 'details',
    component: BookingDetailsComponent
  },
  {
    path: 'payment-return',
    component: PaymentReturnComponent
  }
];
